import PropTypes from "prop-types";
import { Radio } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { getAddonRate } from "../utils/reservationHelpers";

const InsuranceOptionCard = ({ item, selected, disabled, onSelect, t }) => {
    const rate = getAddonRate(item);

    return (
        <button
            type="button"
            disabled={disabled}
            onClick={onSelect}
            className={`w-full rounded-xl border p-4 text-left transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${
                selected ? "border-[#5D5DF6] bg-[#5D5DF6]/[0.03]" : "border-[#E6EAF2] bg-white hover:border-[#5D5DF6]/40"
            }`}>
            <div className="flex items-start gap-3">
                <Radio checked={selected} className="!mt-0.5 !shrink-0" />
                <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-start justify-between gap-3">
                        <p className="fontSemi text-base text-[#222222]">{item.name}</p>
                        <p className="fontSemi shrink-0 text-base text-[#5D5DF6]">
                            ${rate.toFixed(2)} / {t("perDay")}
                        </p>
                    </div>

                    {Array.isArray(item.featureList) && item.featureList.length > 0 ? (
                        <ul className="mt-2 space-y-1.5">
                            {item.featureList.map((feature) => (
                                <li
                                    key={`${item.id}-${feature.text}`}
                                    className="fontRegular flex items-start gap-2 text-sm text-[#5F6673]">
                                    <span className="mt-0.5 shrink-0">
                                        {feature.isActive ? (
                                            <CheckOutlined className="!text-[#16A34A]" />
                                        ) : (
                                            <CloseOutlined className="!text-[#98A2B3]" />
                                        )}
                                    </span>
                                    <span>{feature.text}</span>
                                </li>
                            ))}
                        </ul>
                    ) : item.desc ? (
                        <p className="fontRegular mt-2 text-sm text-[#7F8796]">{item.desc}</p>
                    ) : null}
                </div>
            </div>
        </button>
    );
};

InsuranceOptionCard.propTypes = {
    item: PropTypes.object.isRequired,
    selected: PropTypes.bool,
    disabled: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

export default InsuranceOptionCard;
